import React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';

const Warning = (props) => {

    let zeroMargin = {
    };

    if (props.margin) {
        zeroMargin = {
            marginTop: 13
        };
    }

    return (
        <div>
            {props.value && (<div style={{ ...zeroMargin }}>
                <MessageBar
                    messageBarType={MessageBarType.warning}
                    dismissButtonAriaLabel="Close">
                    {props.value}
                </MessageBar>
            </div>)}
        </div>
    );
}

export default Warning;